import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useMilestones } from "../TraningAcademy.hook";
import { fields, fieldsReady } from "../constants";

export const AddEditMilestones = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useMilestones(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const generateDynamicFields = (payload: any) => {
    if (!payload) return { milestones: [] };

    const fields: any[] = [];

    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (key === "image") {
        fields.push({
          name: "image",
          label: "Image",
          type: "file",
          className: "col-span-6",
          placeholder: "Upload an image",
          rules: { required: "Image is required" },
          accept: "image/*",
        });
      } else if (key === "img_desc") {
        fields.push({
          name: "img_desc",
          label: "Image Description",
          type: "richText",
          className: "col-span-6",
          placeholder: "Enter image description",
          rules: { required: "Image description is required" },
        });
      } else if (key === "Hyperlink" && Array.isArray(value)) {
        const hyperlinkIdx = value.length > 0 ? value : [{}];
        fields.push({
          fieldName: "Hyperlinks",
          fieldValue: "Hyperlink",
          type: "dynamicRow",
          className: "col-span-12",
          name: "Hyperlink",
          dynamicFormType: "dynamicRow",
          placeholder: "",
          label: "Hyperlinks",
          rowConfig: hyperlinkIdx.map((_: any, linkIdx: number) => ({
            fields: [
              {
                fieldName: `Text ${linkIdx + 1}`,
                fieldValue: `Hyperlink[${linkIdx}].text`,
                type: "input",
                className: "col-span-6",
                name: `Hyperlink[${linkIdx}].text`,
                label: `Text ${linkIdx + 1}`,
                placeholder: "Add Text",
                validation: { required: "Text is Required" },
              },
              {
                fieldName: `Link ${linkIdx + 1}`,
                fieldValue: `Hyperlink[${linkIdx}].link`,
                type: "file",
                className: "col-span-6",
                name: `Hyperlink[${linkIdx}].link`,
                label: `Link ${linkIdx + 1}`,
                usedFileType: ".pdf",
                placeholder: "Add Hyperlink",
              },
            ],
          })),
        });
      }
    });

    return { milestones: fields };
  };

  useEffect(() => {
    const fetchData = async () => {
      if (editData?.[0]?.id) {
        const id = editData[0].id;
        await fieldsReady(id);
        setFieldData(fields);
      } else if (dataById?.payload) {
        const dynamicFields = generateDynamicFields(dataById.payload);
        setFieldData(dynamicFields);
      } else {
        await fieldsReady();
        setFieldData(fields);
      }
    };

    fetchData();
  }, [editData, dataById]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.[0]?.published)
          : false,
      image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: dataById?.payload?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editData?.[0]?.image,
            },
          ]),
      img_desc: dataById ? decodeHTML(dataById.payload.img_desc) : editData ? decodeHTML(editData?.[0]?.img_desc) : "",
      Hyperlink: dataById?.payload?.Hyperlink
        ? dataById.payload.Hyperlink.map((link: { id: string; text: string; link: string }) => ({
            id: link.id,
            text: decodeHTML(link.text),
            link: decodeHTML([
              {
                uid: "-1",
                name: "field_pdfurl.pdf",
                status: "done",
                url: link.link,
              },
            ]),
          }))
        : editData?.[0]?.Hyperlink
          ? editData[0].Hyperlink.map((link: { id: string; text: string; link: string }) => ({
              id: link.id,
              text: decodeHTML(link.text),
              link: decodeHTML([
                {
                  uid: "-1",
                  name: "field_pdfurl.pdf",
                  status: "done",
                  url: link.link,
                },
              ]),
            }))
          : [],
    },
    fields: fieldData?.milestones,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("datasssssssssss", data);
    let imageKeys: any = ["image", "link"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const hyperlinkData = data.Hyperlink;
    let dynamicImageKeys: string[] = ["link"];
    for (const row of hyperlinkData) {
      for (const key of dynamicImageKeys) {
        try {
          let field = row[key];
          if (field && Array.isArray(field) && field.length > 0) {
            const fileObj = field[0];

            if (fileObj.originFileObj) {
              const formData = new FormData();
              formData.append("upload-file", fileObj.originFileObj);
              formData.append("application", "CORPORATE");
              const res: any = await post("management/upload-file", formData);

              if (res && res.response?.data) {
                row[key] = res.response.data;
              }
            } else if (fileObj.url) {
              row[key] = fileObj.url;
            }
          }
        } catch (error) {
          console.error(`Error processing ${key} in row ${row.id}:`, error);
        }
      }
    }
    data.Hyperlink = hyperlinkData.map((item: any) => {
      if (item.id && item.id.toString().startsWith("new")) {
        const { id, ...rest } = item;
        return rest;
      }
      return item;
    });

    let numberKeys: any = ["year", "sequence", "field_awards_sequence", "field_awards_year"];

    for (const key of numberKeys) {
      try {
        let field = data[key];
        if (field !== undefined && field !== null && field !== "") {
          data[key] = Number(field);
        }
      } catch (error) {
        console.error(`Error converting ${key} to number:`, error);
      }
    }
    console.log("trainingdatas", data);

    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "milestones",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_Milestones",
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        title: data?.img_desc ?? "",
        ...data,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Milestones`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/airports-academy-achievement/${editData?.[0]?.id || dataById?.payload?.id}`
              : `${corporateHost}/api/create/airports-academy-achievement`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Malaysia Airports Academy"
      />
    </ContentWrapper>
  );
};
